<template>
  <el-dialog :visible.sync="dialogVisible" title="空压机24/7报告" :before-close="doClose" >
  <div class="compressor-report">
    <el-container>
      <el-main>
        <div class="report-details" v-if="reportConfig.baseInfoEnabled">
          <div>
            <label>SN:</label>
            <span>{{ healthReportProp.deviceBasicInfo.hardwareSn || "N/A" }}</span>
          </div>
          <div>
            <label>客户:</label>
            <span>{{ healthReportProp.deviceBasicInfo.customerName|| 'N/A' }}</span>
          </div>
          <div>
            <label>机组型号:</label>
            <span>{{ healthReportProp.deviceBasicInfo.modelDesc || 'N/A'}}</span>
          </div>
          <div>
            <label>责任工程师:</label>
            <span>{{ healthReportProp.deviceBasicInfo.responsibleEngineerName || 'N/A'}}</span>
          </div>
          <div>
            <label>合同类型:</label>
            <span>{{ healthReportProp.deviceBasicInfo.contractStatus || 'N/A'}}</span>
          </div>
          <div>
            <label>报告时间:</label>
            <span>{{ healthReportProp.deviceBasicInfo.reportTime || 'N/A' }}</span>
          </div>
        </div>
        <hr />
        <div class="core-data">
          <div class="data-section" >
            <h2>周期核心数据:</h2>
            <div v-if="reportConfig.statInfoEnabled">
              <div class="data-item">
                <label>运行小时:</label>
                <span>{{ healthReportProp.cycleCoreData.calcRunningHour }}</span>
                <span v-if="healthReportProp.cycleCoreData && healthReportProp.cycleCoreData.calcRunningHour && healthReportProp.previousCycleCoreData && healthReportProp.previousCycleCoreData.calcRunningHour" style="margin-left: 5px;">
                    <i v-if="healthReportProp.cycleCoreData.calcRunningHour > healthReportProp.previousCycleCoreData.calcRunningHour" class="el-icon-top" style="color: red;"></i>
                    <i v-else class="el-icon-bottom" style="color: green;"></i>
                  </span>
              </div>
              <div class="data-item">
                <label>加载小时:</label>
                <span>{{ healthReportProp.cycleCoreData.calcLoadedHour }}</span>
                <span v-if="healthReportProp.cycleCoreData &&healthReportProp.cycleCoreData.calcLoadedHour && healthReportProp.previousCycleCoreData && healthReportProp.previousCycleCoreData.calcLoadedHour" style="margin-left: 5px;">
                    <i v-if="healthReportProp.cycleCoreData.calcLoadedHour > healthReportProp.previousCycleCoreData.calcLoadedHour" class="el-icon-top" style="color: red;"></i>
                    <i v-else class="el-icon-bottom" style="color: green;"></i>
                  </span>
              </div>
              <div>
                <label>加载率:</label>
                <span>{{healthReportProp.cycleCoreData.loadRate }}</span>
              </div>
              <div>
                <label>利用率:</label>
                <span>{{ healthReportProp.cycleCoreData.rate }}</span>
              </div>
            </div>
            <div v-if="reportConfig.alertInfoEnabled">
              <div>
                <label>Trip数:</label>
                <span>{{ healthReportProp.cycleCoreData.tripInfo && healthReportProp.cycleCoreData.tripInfo.length }}</span>
              </div>
              <div>
                <label>Warning数:</label>
                <span>{{ healthReportProp.cycleCoreData.warningInfo && healthReportProp.cycleCoreData.warningInfo.length }}</span>
              </div>
              <div>
                <label>Top 3 Trip:</label>
                <span v-for="item in healthReportProp.cycleCoreData.tripInfo || []">{{ item.alarmContent }}:{{ item.alarmCount }}</span>
              </div>
            </div>
          </div>
          <div class="data-section" v-if="reportConfig.statInfoEnabled">
            <h2>生命周期核心数据:</h2>
            <div class="data-item">
              <label>运行小时:</label>
              <span>{{ healthReportProp.lifecycleCoreData.calcRunningTime }}</span>
              <span v-if="healthReportProp.lifecycleCoreData && healthReportProp.lifecycleCoreData.calcRunningTime != null && healthReportProp.previousLifecycleCoreData && healthReportProp.previousLifecycleCoreData.calcRunningTime != null" style="margin-left: 5px;">
                    <i v-if="healthReportProp.lifecycleCoreData.calcRunningTime > healthReportProp.previousLifecycleCoreData.calcRunningTime" class="el-icon-top" style="color: red;"></i>
                    <i v-else class="el-icon-bottom" style="color: green;"></i>
                  </span>
            </div>
            <div>
              <label>加载小时:</label>
              <span>{{healthReportProp.lifecycleCoreData.calcLoadedTime }}</span>
            </div>
            <div>
              <label>加载率:</label>
              <span>{{healthReportProp.lifecycleCoreData.loadRate }}</span>
            </div>
            <div>
              <label>利用率:</label>
              <span>{{ healthReportProp.lifecycleCoreData.rate }}</span>
            </div>
          </div>
        </div>
        <hr />
        <div class="charts">
          <div>
            <h2>主机近期利用率曲线:</h2>
            <div class="infoLine" ref="UseRateLine" style="height: 200px"></div>
          </div>
          <div>
            <h2>主机近期加载率曲线:</h2>
            <div class="infoLine" ref="LoadingLine" style="height: 200px"></div>
          </div>
          <div>
            <h2>客户近期能耗消费曲线 (选项):</h2>
            <!-- 这里可以插入 ECharts 图表 -->
          </div>
          <div>
            <h2>设备振动预测性维护 (选项):</h2>
            <!-- 这里可以插入 ECharts 图表 -->
          </div>
          <div>
            <h2>洞察 (选项):</h2>
            <!-- 这里可以插入 ECharts 图表 -->
          </div>
        </div>
      </el-main>

    </el-container>
    <el-button class="export-button" ref="exportButton" @click="exportToWord">导出为Word</el-button>
  </div>
  </el-dialog>
</template>


<script>
import bus from "./bus";
import {
  GetCycleCoreData,
  GetDeviceBasicInfo,
  GetDeviceRateList,
  GetLifecycleCoreData,
  GetPreviousLifecycleCoreData,
  GetPreviousCycleCoreData
} from "@/api/api";
import htmlDocx from 'html-docx-js/dist/html-docx'
import html2canvas from "html2canvas";
import saveAs from 'file-saver'

export default {
  name: 'healthReport',
  data() {
    return {
      dialogVisible: true,
      reportConfig: {
        dialogVisible: false,
        baseInfoEnabled: true,
        statInfoEnabled: true,
        alertInfoEnabled: false,
        energySensorEnabled: false,
        vibrationSensorEnabled: false,
        insightsEnabled: false,
        serviceInfoEnabled: false,
        sparePartInfoEnabled: false,
        externalImportEnabled: false,
        showFileImportDialog: false,
        reportType: "",
        cycleType: ""
      },
      healthReportProp: {
        dsn: "",
        gsn: "",
        deviceBasicInfo: {},
        deviceUseRateList: [],
        cycleCoreData: {},
        deviceLoadedRateList: [],
        lifecycleCoreData: {},
        previousCycleCoreData: {},
        previousLifecycleCoreData: {}
      },
      useRateLineChart: null, // 保存 UseRateLine 的 ECharts 实例
      loadingLineChart: null
    };
  },
  created() {
    var vm = this;
    this.dialogVisible = true;
    this.$nextTick(() => {
      console.info(this.$refs.UseRateLine); // 此时应该可以访问
      console.info(this.$refs.LoadingLine); // 此时应该可以访问
    });

    // 用$on事件来接收参数
    bus.$on('reportConfig', (data) => {

      vm.reportConfig = data;
      this.getHealthDetailInfo(vm.reportConfig)
          .then(() => {
            this.renderLine();
          });
    })
  },
  beforeDestroy() {
    // 销毁事件监听器
    bus.$off('reportConfig', this.handleReportConfig);
  },
  methods: {
    renderLine() {
      this.$nextTick(() => {
        this.InitLoadingLine(this.healthReportProp.deviceLoadedRateList);
        this.InitUseRateLine(this.healthReportProp.deviceUseRateList);
      });
    },
    doClose() {
      this.$emit("dialogVisibleEvent", false);
      this.closeHealthReport();
      // 销毁 ECharts 实例
      if (this.useRateLineChart) {
        this.useRateLineChart.dispose();
        this.useRateLineChart = null;
      }
      if (this.loadingLineChart) {
        this.loadingLineChart.dispose();
        this.loadingLineChart = null;
      }

    },
    closeHealthReport() {
      this.healthReportProp = {
        dsn: "",
        gsn: "",
        deviceBasicInfo: {},
        deviceUseRateList: [],
        cycleCoreData: {},
        deviceLoadedRateList: [],
        lifecycleCoreData: {}
      };
      this.reportConfig = {};
    },
    async getHealthDetailInfo(row) {
      let that = this;
      this.healthReportProp.dsn = row.dsn;
      this.healthReportProp.gsn = row.gsn;
      this.healthReportProp.deviceUseRateList = await this.deviceUseRateList();
      this.healthReportProp.deviceBasicInfo = await this.deviceBasicInfo();
      this.healthReportProp.deviceLoadedRateList = await this.deviceLoadedRateList();
      this.healthReportProp.cycleCoreData = await this.cycleCoreData();
      this.healthReportProp.lifecycleCoreData = await this.lifecycleCoreData();

      this.healthReportProp.previousCycleCoreData = await this.previousCycleCoreData();
      this.healthReportProp.previousLifecycleCoreData = await this.previousLifecycleCoreData();
    },
    async deviceBasicInfo() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetDeviceBasicInfo(this.healthReportProp.dsn, this.healthReportProp.gsn);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },
    async deviceUseRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'use', this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async cycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetCycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return {};
        }
        res2.result.WarningInfo = JSON.parse(res2.result.WarningInfo || "[]");
        res2.result.TripInfo = JSON.parse(res2.result.TripInfo || "[]");
        return res2.result;
      }
      return {};
    },
    async previousCycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetPreviousCycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return {};
        }
        res2.result.WarningInfo = JSON.parse(res2.result.WarningInfo || "[]");
        res2.result.TripInfo = JSON.parse(res2.result.TripInfo || "[]");
        return res2.result;
      }
      return {};
    },
    async deviceLoadedRateList() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res2 = await GetDeviceRateList(this.healthReportProp.dsn, this.healthReportProp.gsn, 'loaded', this.reportConfig.cycleType);
        if (!res2 || !res2.result) {
          return [];
        }
        return res2.result;
      }
      return [];
    },
    async lifecycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetLifecycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },

    async previousLifecycleCoreData() {
      if (this.healthReportProp.dsn && this.healthReportProp.gsn) {
        let res = await GetPreviousLifecycleCoreData(this.healthReportProp.dsn, this.healthReportProp.gsn, this.reportConfig.cycleType);
        if (!res || !res.result) {
          return {};
        }
        return res.result;
      }
      return {};
    },

    renderEcharts(UseRateLineContainer, data, title) {
      var that = this;

      var UseRateLine = this.$echarts.init(UseRateLineContainer)
      var timeLine = data.dayTimeList;
      var dataLine = data.dayDataList;

      var optionUseRateLine = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "line",
          },
          backgroundColor: "#141518",
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#fff",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: "{b}<br />{a} : {c}% ",
        },
        grid: {
          top: 10,
          left: 0,
          right: 0,
          bottom: 0,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: '#fff'
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          boundaryGap: false,
          data: timeLine,
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: '#fff'
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: {
          name: title,
          type: "line",
          smooth: true,
          showAllSymbol: false,
          symbol: "circle",
          symbolSize: 5,
          lineStyle: {
            normal: {
              color: "rgba(255,255,255,1)",
            },
          },
          itemStyle: {
            color: "rgba(58,64,73,1)",
            borderColor: "rgba(255,255,255,1)",
            borderWidth: 1,
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {offset: 0, color: "rgba(255,255,255,0.5)"},
                {offset: 1, color: "rgba(255,255,255,0)"},
              ]),
            },
          },
          data: dataLine,
          cursor: "default",
        },
      };
      UseRateLine.setOption(optionUseRateLine);

      window.addEventListener("resize", () => {
        UseRateLine.resize();
      });
      return UseRateLine;
    },
    InitUseRateLine(data) {
      this.$nextTick(() => {
        var UseRateLineContainer = this.$refs.UseRateLine;

        this.useRateLineChart = this.renderEcharts(UseRateLineContainer, data, this.$t('desc.UseRate'));
      });

    },
    InitLoadingLine(data) {
      this.$nextTick(() => {
        var LoadingLineContainer = this.$refs.LoadingLine;
        this.loadingLineChart = this.renderEcharts(LoadingLineContainer, data, this.$t('desc.Loading'));
      });

    },
    exportToWord: async function () {
      // 确保图表已经渲染
      await this.$nextTick();

      // 获取图表容器
      const useRateLineContainer = this.$refs.UseRateLine;
      const loadingLineContainer = this.$refs.LoadingLine;

      // 将图表转换为图片
      const useRateLineImage = await html2canvas(useRateLineContainer, {backgroundColor: '#000000'});
      useRateLineImage
      const loadingLineImage = await html2canvas(loadingLineContainer, {backgroundColor: '#000000'});

      // 将图片转换为 base64
      const useRateLineBase64 = useRateLineImage.toDataURL('image/png');
      const loadingLineBase64 = loadingLineImage.toDataURL('image/png');

      // 创建一个隐藏的 img 元素来保存图片
      const useRateLineImg = document.createElement('img');
      useRateLineImg.src = useRateLineBase64;
      useRateLineImg.style.display = 'none';
      document.body.appendChild(useRateLineImg);

      const loadingLineImg = document.createElement('img');
      loadingLineImg.src = loadingLineBase64;
      loadingLineImg.style.display = 'none';
      document.body.appendChild(loadingLineImg);

      // 查询需要替换的元素
      const useRateLineElement = useRateLineContainer;
      const loadingLineElement = loadingLineContainer;
      let newUseRateLineImg = null;
      let newLoadingLineImg = null;

      if (useRateLineElement) {
        // 创建新的 img 元素
        newUseRateLineImg = document.createElement('img');
        newUseRateLineImg.src = useRateLineBase64;
        newUseRateLineImg.style.width = '100%';
        newUseRateLineImg.style.height = '200px';

        // 替换元素
        useRateLineElement.parentNode.replaceChild(newUseRateLineImg, useRateLineElement);
      }

      if (loadingLineElement) {
        // 创建新的 img 元素
        newLoadingLineImg = document.createElement('img');
        newLoadingLineImg.src = loadingLineBase64;
        newLoadingLineImg.style.width = '100%';
        newLoadingLineImg.style.height = '200px';

        // 替换元素
        loadingLineElement.parentNode.replaceChild(newLoadingLineImg, loadingLineElement);
      }
      console.info(this.$refs.exportButton)

      const exportButton = this.$refs.exportButton.$el;
      if (exportButton) {
        exportButton.remove();
      }

      // 获取报告内容
      const reportContent = document.querySelector('.compressor-report').innerHTML;

      // 创建一个隐藏的 div 来保存报告内容
      const reportDiv = document.createElement('div');
      reportDiv.innerHTML = reportContent;
      reportDiv.style.display = 'none';
      document.body.appendChild(reportDiv);

      // 将报告内容转换为 Word 文档
      const doc = htmlDocx.asBlob(reportDiv.innerHTML);
      saveAs(doc, 'health_report.docx')

      // 清理
      document.body.removeChild(useRateLineImg);
      document.body.removeChild(loadingLineImg);
      document.body.removeChild(reportDiv);

      this.doClose();
    }
  }
};
</script>

<style scoped>
.compresser-report {
  font-family: Arial, sans-serif;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-details div {
  margin-bottom: 10px;
}

.core-data .data-section {
  width: 48%;
  display: inline-block;
  vertical-align: top;
  margin-right: 2%;
}

.charts h2 {
  margin-top: 20px;
}

.compresser-report {
  font-family: Arial, sans-serif;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.report-details div {
  margin-bottom: 10px;
}

.core-data .data-section {
  width: 48%;
  display: inline-block;
  vertical-align: top;
  margin-right: 2%;
}

.charts h2 {
  margin-top: 20px;
}

.infoLine {
  height: 200px; /* 确保高度明确 */
}

.export-button {
  right: 20px; /* 距离右侧20像素 */
  top: calc(100% + 100px); /* 距离顶部100像素 */
  z-index: 1000; /* 确保按钮在最上层 *//* 距离顶部100像素 */
}
</style>